(ns dre.components.user-menu.views
  (:require
   [clojure.string :as str]
   [dre.app.events :as-alias app]
   [dre.app.router :as router]
   [dre.components.dropdown :refer [dropdown dropdown-list]]
   [dre.components.icon :refer [svg]]
   [dre.components.privacy.utils :as privacy]
   [dre.components.privacy.views :refer [privacy-notice]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.components.user-menu.notifications.views :as notifications]
   [dre.config :as-alias conf]
   [dre.i18n.events :as-alias i18n]
   [dre.i18n.views :refer [tr]]
   [dre.modals.events :as-alias modals]
   [dre.pages.events :as-alias pages]
   [dre.widgets.events :as-alias widgets]
   [dre.utils.bem :as bem]
   [dre.utils :as utils]
   [re-frame.core :as rf]
   [reagent.core :as r]))


(def component-name :user-menu)

(defn help-button
  []
  [tooltip-wrapper "Need help?" [:button
                    {:class (bem/bm :button :bare)}
                    [:div "?"]
                    [svg :common :circle]]])


(defn help-dropdown
  [user]
  [:div
   {:class (bem/be component-name :help-dropdown)}
   [dropdown
    {:alignment :right

     :anchor
     [help-button]

     :content
     [dropdown-list
      [[:a
        {:href "https://8867135.hs-sites.com/search"
         :download true
         :target "_blank"}
        [tr "FAQs + Tips"]]
       [:a
        {:on-click #(rf/dispatch [::router/redirect-to-handler :videos])}
        [tr "Videos"]]
       [:a
        {:href "https://share.hsforms.com/1d4rgNXCJRR27z4DXir9PEA5a1xb"
         :target "_blank"}
        [tr "Request support"]]
       [:a
        {:href "https://s3.us-west-1.amazonaws.com/public.docsearch.dre/LitSearch Quick Guide_March 2024.pdf"
         :download true
         :target "_blank"}
        [tr "Download quick guide"]]
       [:a
        {:href "https://s3.us-west-1.amazonaws.com/public.docsearch.dre/Lit Search Operators Quick Guide_March 2024.pdf"
         :download true
         :target "_blank"}
        [tr "Download Search Operators Quick Guide"]]]]}]])


(defn user-button
  [user]
  [tooltip-wrapper "User menu" [:button
                                {:class (bem/bm :button :bare)}
                                [:div
                                 (str/join "" (map first (str/split (:name user "") #"\s" 2)))]
                                [svg :common :circle]]])


(defn language-switcher
  []
  (let [{current :language} @(rf/subscribe [::i18n/state])
        supported-languages @(rf/subscribe [::conf/get :supported-languages])]
    (->> supported-languages
         (map (fn [lang]
                (if (= lang current)
                  (str/upper-case lang)
                  [:a
                   {:href "#"
                    :on-click #(rf/dispatch [::i18n/set-lang lang])}
                   (str/upper-case lang)])))
         (interpose " ")
         (into [:<>]))))


(defn user-dropdown
  [user]
  (let [env @(rf/subscribe [::conf/get :env])]
    [:div
     {:class (bem/be component-name :user-dropdown)}
     [dropdown
      {:alignment :right

       :anchor
       [user-button user]

       :content
       [dropdown-list
        [#_[:span
            [tr "Preferred language: "]
            [language-switcher]]
         (when-not (or (utils/restricted-role? user) (not (utils/datahub-role? user env)))
           [:a
            {:href "/swagger"}
            [tr "Public API documentation"]])
         (when (utils/admin-role? user)
           [:a
            {:href "/swagger-all"}
            [tr "Complete API documentation"]])
         (when (utils/admin-role? user)
           [:a
            {:on-click #(rf/dispatch [::router/redirect-to-handler :annotator])}
            [tr "Annotator"]])
         (when (utils/admin-role? user)
           [:a
            {:on-click #(rf/dispatch [::router/redirect-to-handler :pubmed-compare])}
            [tr "PubMed Compare"]])
         (when (or (utils/admin-role? user) (utils/sanofi-csv-export-role? user))
           [:a
            {:on-click #(rf/dispatch [::router/redirect-to-handler :admin])}
            [tr "Admin"]])
         (when-not (utils/restricted-role? user)
           [:a
            {:on-click #(rf/dispatch [::modals/set-modal :app-settings])}
            [tr "App Settings"]])
         (when (utils/datahub-role? user env)
           [:a
            {:on-click #(rf/dispatch [::widgets/reset-widgets-layout])}
            [tr "Reset widget layouts"]])
         [:a
          {:href privacy/privacy-pdf-url
           :target "_blank"}
          [tr "Privacy policy"]]
         [:a
          {:href "https://drevidence.com/"}
          [tr "About Dr.Evidence"]]
         [:a
          {:href "https://platform.doctorevidence.com/"}
          [tr "Dr.Evidence Home"]]
         [:a
          {:on-click #(rf/dispatch [::app/logout])}
          [tr "Logout"]]]]}]]))

(defn user-menu
  [_user]
  (fn [user]
    (r/create-class
     {:reagent-render
      (fn []
        [:div
         {:class component-name}
         (when-not (utils/restricted-role? user)
           [notifications/broadcast-dropdown component-name user])
         [help-dropdown user]
         [user-dropdown user]
         (when-not (utils/dev-role? user)
           [privacy-notice])])})))
